export const enviarcheckin = {
    text1: "Invia check-in",
    text2: "Invia un link ai tuoi ospiti per effettuare il check-in prima di arrivare all'alloggio.",
    text3: "Seleziona l'alloggio *",
    text4: "Inserisci il nome",
    text5: "Nome dell'ospite *",
    text6: "Numero di telefono dell'ospite *",
    text7: "Email",
    text8: "Email dell'ospite *",
    text9: "Invia",
    text09: "Programma",
    text10: "Invio del check-in in corso, attendi",
    text11: "Devi selezionare un alloggio per assegnare il check-in",
    text12: "Il campo nome è obbligatorio",
    text13: "Il campo telefono è obbligatorio",
    text14: "L'email è obbligatoria",
    text15: "Quasi fatto",
    text16: "Ciao ",
    text17: "! Siamo ",
    text18: ". Ti inviamo questo messaggio affinché tu possa effettuare il check-in prima di arrivare al nostro alloggio, evitando così possibili attese alla reception e, soprattutto, il consumo inutile di carta. \n\nPer un pianeta più verde!",
    text19: "Ciao ",
    text20: "! Siamo ",
    text21: ". Ti inviamo questo messaggio affinché tu possa effettuare il check-in prima di arrivare al nostro alloggio, evitando così possibili attese alla reception e, soprattutto, il consumo inutile di carta. <br> <br> Per un pianeta più verde!",
    text22: "Check-in inviato con successo",
    text23: "Caricamento ...",

    // Corrections
    p1: "Invia link per il check-in",
    p2: "Crea prenotazione",
    p3: "Informazioni sulla prenotazione",
    p4: "Nome dell'ospite responsabile",
    p5: "Data di check-in",
    p6: "Data di check-out",
    p7: "Numero di ospiti",
    p8: "Seleziona una camera",
    p9: "Non specificato",
    p10: "Seleziona il numero della camera",
    p11: "Check-in online",
    p12: "Prezzo della prenotazione",
    p13: "Crea prenotazione",
    p14:`Ora invita il tuo ospite a procedere con il check-in.`,
    p15:`Costo aggiuntivo`,

    p16:`Specifica la camera`,
    p17:`Se selezioni una camera, invieremo le chiavi associate`,
    p18:`Seleziona camera`,
    p19:`Nessun risultato trovato. Prova un altro termine.`,
    p20:`Nessuna camera disponibile.`,
    p21:`Premi invio per selezionare`,
    p22:`Selezionata`,
    p23:`Premi invio per rimuovere`,
    p24:`Nessuna opzione disponibile`,
    p25: `Prenotazione creata con successo.`,
    p26: `La prenotazione è stata completata con successo. Puoi tornare alla pagina iniziale.`,
    p27: `Invito inviato con successo.`,
    p28: `Accetta`,
};
